// extracted by mini-css-extract-plugin
export default {"label":"cec899174b2f897ba73e479b6822b3a6","value":"b8301d862077f05cdc1711ba3ab293ae","noLabel":"_9ccfa5d399608dfa029a1b8b603ea9cf","rtl":"b8a141aa09f5c5e9acee8dfa52fa8e8a"};